import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from 'src/utils/filters/get-selected-filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  items: { value: string; label: string }[];
}

export const FloorsFilterPopover = ({
  filters,
  handleChangeFilterValue,
  items,
}: Props) => {
  const { t } = useTranslation(['statistics']);

  const filterGroup: FilterGroup<string> = {
    id: 1,
    type: 'floors',
    label: t('statistics:common.filters.floor.title'),
    singleOption: false,
    filterOperator: 'custom',
    items,
  };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={getSelectedFilters(filters, filterGroup.type)}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items}
    />
  );
};
